import { useState } from "react";
import { toast } from "sonner";
import { Fish, Radar, Loader2, ExternalLink } from "lucide-react";
import { api, BRAND } from "@/lib/api";

export default function Header({onScanDone, isAdmin = true, agentName = "" }) {
  const [scanning, setScanning] = useState(false);

  const runScan = async () => {
    setScanning(true);
    const t = toast.loading("Veille en cours — lecture de vos sources, analyse IA… (1 à 5 min)");
    try {
      let scan = await api.scanManual();
      for (let i = 0; i < 150 && scan.status === "running"; i++) {
        await new Promise(r => setTimeout(r, 4000));
        scan = (await api.scans()).find(x => x.id === scan.id) || scan;
      }
      if (scan.status === "running") {
        toast.message("Veille toujours en cours — les buzz apparaîtront dès qu'elle sera terminée", { id: t });
      } else if (scan.status === "completed") {
        toast.success(`Veille terminée · ${scan.trend_count} tendances détectées`, { id: t });
        onScanDone?.();
      } else {
        toast.error(`Veille échouée: ${scan.error || "erreur inconnue"}`, { id: t });
      }
    } catch (e) {
      toast.error(`Veille impossible: ${e?.response?.data?.detail || e.message}`, { id: t });
    } finally {
      setScanning(false);
    }
  };

  return (
    <header className="glass sticky top-0 z-30 border-b border-[#dddfe2]/60">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-10 h-16 flex items-center justify-between gap-2">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-[#1877f2] to-[#42a5f5] flex items-center justify-center shadow-lg shadow-orange-900/40 shrink-0">
            <Fish className="w-4.5 h-4.5 text-white" strokeWidth={2.4} />
          </div>
          <div className="leading-tight min-w-0 hidden sm:block">
            <div className="font-display font-bold text-[15px] tracking-tight truncate">
              {isAdmin ? BRAND.name : agentName || "Mon agent BuzzlyMe"}
              {isAdmin && <span className="ml-2 chip chip-fb">17K · FB</span>}
            </div>
            <div className="text-[11px] text-[color:var(--bcs-text-dim)] font-mono-ui">
              AGENT · VEILLE &amp; GÉNÉRATION VIDÉO AI
            </div>
          </div>
          <div className="sm:hidden font-display font-bold text-sm truncate">{isAdmin ? "BCS Agent" : "Mon agent"}</div>
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <span className="chip chip-live hidden lg:inline-flex" data-testid="live-status">
            <span className="pulse-dot" /> Veille AI active
          </span>
          {isAdmin && <a
            href={BRAND.pageUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-ghost hidden md:inline-flex"
            data-testid="facebook-page-link"
          >
            <ExternalLink className="w-3.5 h-3.5" />
            Page Facebook
          </a>}
          <button
            type="button"
            onClick={runScan}
            disabled={scanning}
            className="btn-primary"
            data-testid="manual-veille-button"
          >
            {scanning ? <Loader2 className="w-4 h-4 animate-spin" /> : <Radar className="w-4 h-4" />}
            <span className="hidden sm:inline">{scanning ? "Veille en cours…" : "Lancer une veille"}</span>
            <span className="sm:hidden">{scanning ? "Veille…" : "Veille"}</span>
          </button>
        </div>
      </div>
    </header>
  );
}
